import React from 'react'
import { Jumbotron, Button, Col, Row } from 'reactstrap'
import NavBar2 from '../../Header/navbar2'
import '../other.css'
var Translate = require('react-translate-component')

export default class OtherHeader extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  } 
  render () {
    return (
      <Jumbotron className='jumbotronOtherServicesHeader'>
        <NavBar2/>
        <p className='servicesHeader'><Translate content='dodatkowe_uslugi' /></p>
      </Jumbotron>
    )
  }
}
